import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box';

import grapeIcon from 'static/images/icons/grape.svg'

const wineColor = {
	red: '#e74c39',
	rose: '#ffa3c3',
	white: '#47c0bb',
}

export default function Tag(props) {
	if (!props.tagName) return null;
	return (
		<Box bgcolor="rgba(74, 79, 85, 0.1)" className="wine-tag">
			<Grid container alignItems="center">
				{props.countryCode &&
					<Grid item style={{ lineHeight: 1 }}>
						<span className={`flag-icon flag-icon-${props.countryCode}`} />
					</Grid>
				}
				{!!props.color &&
					<Box className="wine-color" bgcolor={wineColor[props.color]} />
				}
				{props.grape &&
					<img src={grapeIcon} style={{ width: '18px' }} alt="" />
				}
				<Typography>{props.tagName}</Typography>
			</Grid>
		</Box>
	)
}